import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const services = [
    {
      icon: 'ri-shopping-bag-3-line',
      title: '出張買取',
      description: 'ご不要になった家具・家電・骨董品など、専門スタッフがご自宅まで伺い、適正価格で買取いたします。',
    },
    {
      icon: 'ri-truck-line',
      title: '家財撤去',
      description: '引越しや遺品整理に伴う大量の家財も、迅速かつ丁寧に撤去・処分いたします。',
    },
    {
      icon: 'ri-brush-line',
      title: 'ハウスクリーニング',
      description: 'プロの技術で住まいをピカピカに。エアコン・キッチン・浴室など、細部まで徹底清掃します。',
    },
    {
      icon: 'ri-tools-line',
      title: '家電修理',
      description: '冷蔵庫・洗濯機・エアコンなど、各種家電の故障・不具合を迅速に診断・修理いたします。',
    },
    {
      icon: 'ri-home-smile-line',
      title: 'リフォーム',
      description: 'キッチン・浴室・トイレなどの水回りから、内装・外装まで、住まいの快適性を向上させます。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '総合サポート',
      description: '暮らしに関するお困りごとは何でもご相談ください。ワンストップで対応いたします。',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <img
          src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/359363182d8201b63dc659619e9fe0f3.png"
          alt="飛翠ヒーロー背景"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        
        <div className="relative z-10 text-center px-4 w-full max-w-4xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-white mb-6 leading-tight">
            あなたのくらしを支える、<br />信頼のサービス
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
            関東圏で暮らしのお困りごとを解決する、トータルサポート企業
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-[#A7D676] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#96c565] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              お問い合わせはこちら
            </Link>
            <Link
              to="/services"
              className="bg-white/90 text-gray-800 px-8 py-4 rounded-full text-base font-medium hover:bg-white transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              サービス一覧を見る
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-br from-[#A7D676]/5 to-[#76C7E1]/5">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-4">サービス一覧</h2>
            <p className="text-base text-gray-600">暮らしを支える、幅広いサービスをご提供</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#A7D676] to-[#76C7E1] rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/services"
              className="inline-block bg-[#A7D676] text-white px-8 py-3 rounded-full text-base font-medium hover:bg-[#96c565] transition-colors whitespace-nowrap cursor-pointer"
            >
              サービス詳細を見る
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/9eb67403d6f61f07213030ffad1d02f0.png"
                alt="飛翠ロゴ"
                className="rounded-lg shadow-lg w-full h-[600px] object-contain object-center bg-white"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">飛翠について</h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                私たち飛翠は、一都三県で暮らしを支えるトータルサポート企業として、お客様の大切な住まいと生活を守り続けています。
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                「信頼」「誠実」「清潔」をモットーに、出張買取から家財撤去、ハウスクリーニング、家電修理、リフォームまで、幅広いサービスを通じてお客様の快適な暮らしをサポートいたします。東京都、神奈川県、埼玉県、千葉県を中心とした一都三県で、多くのお客様にご愛顧いただいております。
              </p>
              <Link
                to="/about"
                className="inline-block bg-[#76C7E1] text-white px-8 py-3 rounded-full text-base font-medium hover:bg-[#65b6d0] transition-colors whitespace-nowrap cursor-pointer"
              >
                会社概要を見る
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-br from-[#76C7E1]/5 to-[#A7D676]/5">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-4">対応エリア</h2>
            <p className="text-base text-gray-600">関東圏を中心に、幅広く対応しています</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {['東京都', '神奈川県', '埼玉県', '千葉県'].map((area, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-lg transition-shadow"
              >
                <i className="ri-map-pin-line text-4xl text-[#A7D676] mb-3"></i>
                <p className="text-lg font-bold text-gray-800">{area}</p>
              </div>
            ))}
          </div>

          <p className="text-center text-sm text-gray-600 mt-8">
            ※その他のエリアについても、お気軽にご相談ください
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
            お困りごとは、<br className="md:hidden" />お気軽にご相談ください
          </h2>
          <p className="text-base text-gray-600 mb-8 leading-relaxed">
            お電話またはお問い合わせフォームより、お気軽にご連絡ください。<br />
            専門スタッフが丁寧に対応いたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-[#76C7E1] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#65b6d0] transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-mail-line text-xl mr-2"></i>
              お問い合わせフォーム
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
